import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const MentalHealth = lazyWithPreload(() => import('./MentalHealth'))
export const LikeChatMentalHealth = lazyWithPreload(
  () => import('./LikeChatMentalHealth'),
)
